import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * Reusable event card.
 */
const EventCard = ({
  title,
  day,
  month,
  badge,
  location,
  time,
  image,
  link = '/evento',
  variant = 'standard',
  excerpt,
}) => {
  const isUrl = image && (image.startsWith('http') || image.startsWith('/'));

  if (variant === 'hero') {
    return (
      <div className="card news-card news-card--hero animate-on-scroll fade-up">
        <div className="card__image" style={{ aspectRatio: '16/9', minHeight: 280, background: 'var(--color-surface-subtle)', position: 'relative', overflow: 'hidden' }}>
          {isUrl ? (
            <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ width: '100%', height: '100%', background: image || 'linear-gradient(135deg,#1f1a17,#57110f)' }} />
          )}
          <div
            className="event-card__date"
            style={{ position: 'absolute', top: 'var(--space-4)', left: 'var(--space-4)', zIndex: 2 }}
          >
            <span className="event-card__date-day">{day}</span>
            <span className="event-card__date-month">{month}</span>
          </div>
        </div>
        <div className="card__body" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className="card__meta">
            {badge && <span className="badge badge--primary">{badge}</span>}
          </div>
          <h2 className="card__title" style={{ fontSize: 'var(--text-h2)' }}>
            <Link to={link}>{title}</Link>
          </h2>
          {excerpt && <p className="card__excerpt mb-4">{excerpt}</p>}
          {location && <div className="event-card__info mb-2"><Icon name="MapPin" size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} /><span>{location}</span></div>}
          {time && <div className="event-card__info mb-4"><Icon name="Clock" size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} /><span>{time}</span></div>}
          <div>
            <Link to={link} className="btn btn--primary btn--sm">Scopri di più</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <article className={`card event-card animate-on-scroll fade-up`}>
      <div
        className="card__image"
        style={{
          aspectRatio: '16/9',
          background: 'var(--color-surface-subtle)',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        {isUrl ? (
          <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', background: image || 'linear-gradient(135deg,#e27314,#b85a0f)' }} />
        )}
        <div className="event-card__date">
          <span className="event-card__date-day">{day}</span>
          <span className="event-card__date-month">{month}</span>
        </div>
      </div>
      <div className="card__body">
        <div className="card__meta">
          {badge && <span className="badge badge--subtle">{badge}</span>}
        </div>
        <h4 className="card__title">
          <Link to={link}>{title}</Link>
        </h4>
        {location && <div className="event-card__info mt-2"><Icon name="MapPin" size={14} style={{ marginRight: 4 }} /><span>{location}</span></div>}
        {time && <div className="event-card__info mt-1"><Icon name="Clock" size={14} style={{ marginRight: 4 }} /><span>{time}</span></div>}
      </div>
    </article>
  );
};

export default EventCard;
